<template>
  <div>
    <status
      v-for="actor in getActorsOnTile(service.id)"
      :key="actor.id"
      :actor="actor"
      :on-tile="onTile"
      class="float-left mr-1"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Status from '@/components/services/service/Status.vue';

export default {
  name: 'Statuses',
  props: {
    service: {
      type: Object,
      required: true,
    },
    onTile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'getActorsOnTile',
    ]),
  },
  components: {
    Status,
  },
};
</script>

<style scoped>

</style>
